/**
 *描述：传播力指数修订-选择作者弹出框
 *作者：li.lei
 *日期：2017--7-14
 */
"use strict";
angular.module("selectUsersModule", [])
	.controller("selectUsersCtrl", ["$scope", "$q", "$uibModalInstance", "httpService", "item", function($scope, $q, $uibModalInstance, httpService, item) {
		initStatus();
		initData();

		function initStatus() {
			$scope.status = {
				treeOption: {
					nodeChildren: "CHILDREN",
					allowDeselect: false,
					isLeaf: function(node) {
						return node.HASCHILDREN !== "true";
					},
				},
				selectedNode: [],
			};
			$scope.data = {};
			$scope.authorList = [];
		}
		/**
		 * [isShow description]是否选中
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.isShow = function() {
			$scope.data.isshow = $scope.data.isshow === 1 ? 0 : 1;
		};
		/**
		 * [selectProduct description]产品类型
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.selectDepart = function() {
			$scope.data.ditchid = $scope.productTypeSelected.value;
		};
		/**
		 * [initData description]初始化媒体列表
		 */
		function initData() {
			if(item.users.length>0){
				var oldusers=[];
				for(var i=0;i<item.users.length;i++){
					oldusers[i]={};
					oldusers[i].GROUPID = item.users[i].mlfdeptid;
					oldusers[i].COMPANY = item.users[i].mlfdeptname; 
					oldusers[i].USERNAME = item.users[i].nickname;
					oldusers[i].ID = item.users[i].userid;
					oldusers[i].UNAME = item.users[i].username;
				}
				$scope.authorList=oldusers;
			}
			var deffer = $q.defer();
			var param = {
				performanceUnit: "0"
			};
			var initurl = "/mfa/calculator/getMLFGroups"; //获取媒立方组织树(前三级组织)
			httpService.http(initurl, param, "post").then(function(data) {
				$scope.data.treeData = angular.assembleTree(data, 'CHILDREN', "", "", "PARENTID", "GROUPID");

				deffer.resolve();
			});
			return deffer.promise;
		};
		/**
		 * [showAuthor description] 点击部门获取当前部门作者
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.showAuthor = function(node, selected, $parentNode) {
			var deffer = $q.defer();
			$scope.selectedDep = node;
			var param = {
				groupid: node.GROUPID
			}
			var urlgetuser = "/mfa/calculator/getUsersByGroupid";
			httpService.http(urlgetuser, param, "post").then(function(data) {
				$scope.data.options = data;
				deffer.resolve();
			});
			return deffer.promise;

		};
		/**
		 * [setSelected description] 点击选择作者
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.setSelected = function(option) {
			if($.inArray(option, $scope.authorList) > -1) return;
			for(var i=0;i<$scope.authorList.length;i++){
				if($scope.authorList[i].ID==option.ID){
					return;
				}
			}
			var deffer = $q.defer();
			if(item.status == 1) {
				$scope.authorList[0] = option;
			} else {
				$scope.authorList.push(option);
			}
			return deffer.promise;
		};

		/**
		 * [deleteAuthor(item) description] 删除作者
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.deleteAuthor = function(option) {
			for(var i = 0; i < $scope.authorList.length; i++) {
				if(option.ID == $scope.authorList[i].ID) {
					var index = i;
				}
			}
			$scope.authorList.splice(index, 1);
		};

		/**
		 * [filterAuthor(item) description] 筛选作者
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.filterAuthor = function() {
			var deffer = $q.defer();
			var param = {
				searchKey: $scope.data.author
			};
			if($scope.data.author === "") {
				$scope.showAuthor($scope.selectedDep);
				return;
			}
			var urlsearchuser = "/mfa/calculator/searchUserOrDept";
			httpService.http(urlsearchuser, param, "post").then(function(data) {
				if(data.length>0){
					if(data[0].TYPE=="201"){
						return;
					}
				}
				$scope.data.options = [];
				for(var i = 0; i < data.length; i++) {
					$scope.data.options[$scope.data.options.length] = {
						USERNAME: data[i].USERNAME,
						ID: data[i].ID,
						SUGGESTION:data[i].SUGGESTION,
						GROUPID:data[i].CRGROUPID,
						DEPT:data[i].CRGROUPNAME
					};
				}
				deffer.resolve();
			});
			return deffer.promise;
		};
		/**
		 * [confirm description] 确定按钮
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.confirm = function() {
			$scope.para = {
				authorList: $scope.authorList
			};
			$uibModalInstance.close($scope.para);
		};
		/**
		 * [close description] 关闭按钮
		 * @param  {[type]}  [description] 
		 * @return {[type]}      [description] null
		 */
		$scope.close = function() {
			$uibModalInstance.dismiss();
		};
		/**
		 * [showToggle description] 展开指定节点
		 * @param  {[object]} node [description] 当前节点
		 * @return {[type]}      [description] null
		 */
		$scope.showToggle = function(node) {
			if(node.HASCHILDREN !== "true") return;
			if(angular.isUndefined(node.CHILDREN) || node.CHILDREN.length === 0) {
				getChildren(node).then(function(data){
					node.CHILDREN = data;
				});
			}
		};
		/**
		 * [getChildren description] 获取子节点
		 * @param  {[object]} node [description] 当前节点
		 * @return {[type]}      [description] null
		 */
		function getChildren(node) {
			var deffer = $q.defer();
			var params = {
				groupid: node.GROUPID
			};
			httpService.http("/mfa/calculator/getMLFChildGroups", params, "post").then(function(data) {
				deffer.resolve(data.CHILDREN);
			});
			return deffer.promise;
		}
	}]);